import { generateCrossScopeToken } from "@/features/auth/services/crossScope.service";

export const BENEF_APP_URL = import.meta.env.VITE_BENEF_APP_URL || "https://mon-yeati.co";

// Resolved on use: parsing at import time would crash the whole console on a misconfigured URL.
export const getBenefOrigin = (): string => new URL(BENEF_APP_URL).origin;

// Same path as the console's own AUTO_LOGIN_ROUTE, but resolved by the employee app: not reusable.
const BENEF_AUTO_LOGIN_PATH = "/auto-login";

export const createBenefAutoLoginUrl = async (redirectPath?: string): Promise<string> => {
  const { login_token: loginToken } = await generateCrossScopeToken();
  const params = new URLSearchParams({ login_token: loginToken });
  if (redirectPath) params.set("redirect_to", redirectPath);
  return `${BENEF_APP_URL}${BENEF_AUTO_LOGIN_PATH}#${params.toString()}`;
};
